import React from "react";
import styles from "../UserDashboard/UserDashboard.module.css";
import Button from "../../components/common/Button";
import { useNavigate } from "react-router-dom";

export default function AboutGroup() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {/* ================= LEFT COLUMN ================= */}
        <div className={styles.colLeft}>
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>Grupo de Discussão em Terapia Baseada em Processos</h3>
              <small className={styles.muted}>
                Um espaço contínuo de desenvolvimento do raciocínio clínico
              </small>
            </div>

            <p>
              Este grupo foi criado para profissionais que desejam aprofundar o
              raciocínio clínico a partir de uma perspectiva baseada em
              processos, especialmente alinhada à Terapia de Aceitação e
              Compromisso (ACT) e aos modelos contemporâneos de psicoterapia
              contextual.
            </p>

            <p>
              Em vez de focar em protocolos fechados, categorias diagnósticas ou
              soluções padronizadas, o trabalho aqui é orientado pela análise
              funcional, pela compreensão dos processos psicológicos envolvidos
              no sofrimento humano e pela construção de intervenções mais
              sensíveis ao contexto.
            </p>
          </section>

          {/* ===== Vídeo introdutório ===== */}
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>Vídeo introdutório</h3>
              <small className={styles.muted}>
                Entenda como este espaço foi pensado
              </small>
            </div>

            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
                overflow: "hidden",
                borderRadius: "10px",
                background: "#f3f4f6",
              }}
            >
              <iframe
                title="Vídeo introdutório - Grupo de Discussão"
                src="https://www.youtube.com/embed/VIDEO_ID_AQUI"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </section>

          {/* ===== Texto clínico aprofundado ===== */}
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>Como o trabalho clínico é sustentado</h3>
            </div>

            <p>
              O grupo se organiza a partir de encontros regulares, nos quais
              casos clínicos, dilemas de manejo e hipóteses funcionais são
              discutidos coletivamente. O objetivo não é oferecer respostas
              prontas, mas favorecer um espaço de pensamento clínico
              compartilhado.
            </p>

            <p>
              A plataforma digital funciona como um suporte a esse processo,
              oferecendo ferramentas que ajudam a organizar, visualizar e
              aprofundar o raciocínio clínico entre os encontros.
            </p>

            <ul className={styles.list}>
              <li>
                <strong>Formulação baseada em processos:</strong> ferramenta
                visual para organizar hipóteses funcionais, história de
                aprendizagem, processos centrais e direções de valor.
              </li>
              <li>
                <strong>Escalas clínicas:</strong> instrumentos autoaplicáveis
                usados como apoio reflexivo, nunca como diagnóstico ou
                classificação rígida.
              </li>
              <li>
                <strong>Metáforas clínicas:</strong> recursos visuais e
                conceituais para ampliar o repertório terapêutico e facilitar a
                comunicação clínica.
              </li>
            </ul>
          </section>

          {/* ===== Limites e ética ===== */}
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>O que este grupo não é</h3>
            </div>

            <p>
              Para݀ manter clareza ética e evitar confusões comuns, é importante
              explicitar alguns limites deste espaço:
            </p>

            <ul className={styles.list}>
              <li>Não se trata de supervisão clínica individual.</li>
              <li>
                Não substitui formação acadêmica, especializações ou terapia
                pessoal.
              </li>
              <li>
                Não oferece protocolos prontos ou garantias de resultado
                clínico.
              </li>
            </ul>

            <p>
              O grupo existe como um espaço de estudo, reflexão e discussão
              clínica, sustentado pelo compromisso com práticas baseadas em
              evidências, sensibilidade contextual e responsabilidade ética.
            </p>
          </section>
        </div>

        {/* ================= RIGHT COLUMN ================= */}
        <div className={styles.colRight}>
          <section className={styles.card}>
            <h3>Para quem é este grupo</h3>
            <ul className={styles.list}>
              <li>Psicólogos e médicos em prática clínica</li>
              <li>
                Profissionais interessados em ACT e Terapia Baseada em Processos
              </li>
              <li>
                Pessoas que desejam aprofundar o raciocínio clínico além de
                protocolos
              </li>
            </ul>
          </section>

          <section className={styles.card}>
            <h3>Como usar no dia a dia</h3>
            <ul className={styles.list}>
              <li>Utilize a plataforma para organizar hipóteses clínicas</li>
              <li>
                Leve dúvidas, impasses e formulações para os encontros ao vivo
              </li>
              <li>
                Use escalas e metáforas como apoio reflexivo entre sessões
              </li>
            </ul>
          </section>
          <Button onClick={() => navigate("/group-enrollment")}>
            Realizar Inscrição
          </Button>
        </div>
      </div>
    </div>
  );
}
